"use client"

import { useSyncExternalStore } from "react"

import { DEFAULT_SCHEME, parseScheme, SCHEME_ATTRIBUTE, SCHEME_COOKIE, SCHEME_COOKIE_MAX_AGE_SECONDS, type ColorScheme } from "@/lib/color-scheme/scheme"
import { setCookie } from "@/platform/browser/cookies"

const currentScheme = (): ColorScheme => parseScheme(document.documentElement.getAttribute(SCHEME_ATTRIBUTE)) ?? DEFAULT_SCHEME

const subscribe = (onChange: () => void): (() => void) => {
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: [SCHEME_ATTRIBUTE] })
  return () => observer.disconnect()
}

export const useColorScheme = (): ColorScheme => useSyncExternalStore(subscribe, currentScheme, () => DEFAULT_SCHEME)

export const applyColorScheme = (scheme: ColorScheme): void => {
  document.documentElement.setAttribute(SCHEME_ATTRIBUTE, scheme)
  document.querySelector('meta[name="color-scheme"]')?.setAttribute("content", scheme)
  setCookie(SCHEME_COOKIE, scheme, { maxAgeSeconds: SCHEME_COOKIE_MAX_AGE_SECONDS, sameSite: "Lax" })
}
